/**
 * ═══════════════════════════════════════════════════════════════════
 *  TourContext — Shared context for tour state
 * ═══════════════════════════════════════════════════════════════════
 */

import { createContext } from 'react';

const TourContext = createContext(null);

export default TourContext;
